import { useEffect } from "react";

import { useTour } from "hooks/useTour";

export function useDebitoAutomaticoPage() {
  const { showTour, setTourType, setSteps, tourStep, tourType } = useTour();

  useEffect(() => {
    setTourType("debito-automatico");
    setSteps(1);
  }, [showTour, setTourType, setSteps]);

  return { showTour, tourStep, tourType };
}
